import React from 'react'
import BaseComponent from "../pages/base/BaseComponent";
import {Button, ButtonGroup, Col, Modal, Row, Table, Card} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label"
import Endpoint from "enqc-utilities/src/api/Endpoint";
import {isEmpty, isResponseOk} from "enqc-utilities/src/utils/Utilities";
import PropTypes from 'prop-types';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSave, faWindowClose} from "@fortawesome/free-solid-svg-icons";
import {withRouter} from 'react-router-dom';

class CreateAssemblyFromInspectionConfirmationModal extends BaseComponent{


    constructor(props) {
        super(props);
        let {show, inspection} = this.props
        if(isEmpty(inspection)){
            inspection = {}
        }
        this.state = {
            show:show,
            inspection:inspection,
        }
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps!=this.props){
            let {show,  inspection} = nextProps
            this.setState({show, inspection}, () => {
                if(show){
                    // window.history.pushState({ show: true }, '');
                    this.handlePopState = (event) =>{
                        if (show) {
                            this.props.onClose()
                            // window.history.pushState(null, ''); // re-push state to prevent deep back
                            window.history.pushState({ show: true }, '');
                        }
                    }
                    window.addEventListener('popstate', this.handlePopState);
                }else{
                    window.removeEventListener('popstate', this.handlePopState);
                }
            })
        }
    }

    async submit(){
        let {inspection} = this.state
        let model = inspection.model??{}
        this.showPostProgress()
        let params = {}
        params.inspectionId = inspection.id
        params.modelId = model.id
        this.get(Endpoint.API.CREATE_ASSEMBLY_FROM_INSPECTION, {params:params},
            null, (res)=>{
                this.closePostProgress()
                if(isResponseOk(res)){
                    let assembly = res.data
                    this.props.onResult(assembly)
                }
            }, false, true)
    }

    render() {
        let {show, inspection} = this.state
        if(!inspection){
            inspection = {}
        }
        let model = inspection.model??{}
        let modelCategory = model.modelCategory??{}
        // let inspectionCategory = inspection.inspectionCategory
        // if(!inspectionCategory){
        //     inspectionCategory = {}
        // }
        return (
            <>
                {super.render()}
                <Modal
                    as={Modal.Dialog}
                    size="md"
                    centered
                    show={show}
                    onHide={()=>{}}>
                    <Modal.Header className="bg-light">
                        <Row className="p-0 m-0 d-block w-100">
                            <Col className="p-0 m-0 text-center d-block">
                                <h5 className="p-0 m-0 text-center d-block">{label.CreateNewAssemblyConfirmation}</h5>
                            </Col>
                        </Row>
                    </Modal.Header>
                    <Modal.Body className="p-0">
                        <Row className="p-2">
                            <Col>
                                <Table responsive className="align-items-center table-flush p-0">
                                    <thead className="thead-light">
                                    <tr>
                                        <th scope="col">{label.Name}</th>
                                        <th scope="col">{label.Value}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td scope="row" >
                                            {label.Reference}
                                        </td>
                                        <td className='fw-bolder' style={{ whiteSpace: 'normal', wordWrap: 'break-word'}}>
                                            {inspection.reference}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td scope="row" >
                                            {label.SerialCode}
                                        </td>
                                        <td className='fw-bolder' style={{ whiteSpace: 'normal', wordWrap: 'break-word'}}>
                                            {inspection.serialCode??"N/A"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td scope="row" >
                                            {label.ModelCategory}
                                        </td>
                                        <td className='fw-bolder' style={{ whiteSpace: 'normal', wordWrap: 'break-word'}}>
                                            {modelCategory.name}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td scope="row" >
                                            {label.Model}
                                        </td>
                                        <td className='fw-bolder' style={{ whiteSpace: 'normal', wordWrap: 'break-word'}}>
                                            {model.systemType}
                                        </td>
                                    </tr>
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                        <Row className="p-2">
                            <Col className="text-center">
                                <Card className="border-success">
                                    <Card.Body>
                                        <span className="text-success h5">
                                            {label.CreateAssemblyFromInspectionDescriptionInfo}
                                        </span>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <hr className="p-0 m-0"/>
                        <Row className="p-3">
                            <Col className="text-right">
                                <ButtonGroup>
                                    <Button
                                        size="sm"
                                        variant="info"
                                        onClick={async (event) => {
                                            this.props.onClose()
                                        }}>
                                        {label.Cancel}&nbsp;&nbsp;<FontAwesomeIcon icon={faWindowClose}/>
                                    </Button>
                                    &nbsp;
                                    <Button
                                        size="sm"
                                        variant="danger"
                                        onClick={async (event) => {
                                            await this.submit()
                                        }}>
                                        {label.Create}&nbsp;&nbsp;<FontAwesomeIcon icon={faSave}/>
                                    </Button>
                                </ButtonGroup>
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>
            </>
        );
    }

}
CreateAssemblyFromInspectionConfirmationModal.propTypes = {
    show:PropTypes.bool.isRequired,
    inspection:PropTypes.object,
    onClose:PropTypes.func.isRequired,
    onResult:PropTypes.func.isRequired
}

export default withRouter(CreateAssemblyFromInspectionConfirmationModal)
